import React, { Fragment } from 'react';
import { Col, Row } from 'reactstrap';
import { PageAnimation } from '../../Layout/Components/Animation';
import PageTitle from '../../Layout/Components/PageTitle';

import Strings from '../../translations/Translations';
import ShareVideoModule from '../../modules/campaign/share/ShareVideoModule';

export default function Share() {
  return (
    <Fragment>
      <PageAnimation>
        <PageTitle
          heading={Strings('share')}
          subheading=""
          icon="pe-7s-share"
        />

        <Row>
          <Col>
            <ShareVideoModule />
          </Col>
        </Row>
      </PageAnimation>
    </Fragment>
  );
}
